export enum CardStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  REMOVED = "REMOVED",
  CREATED = "CREATED"
}
